import { MULTISPORT_PHRASES } from "./consts";

export const isMultisportPhrase = (phrase: string): boolean => {
  if (!phrase || typeof phrase !== "string") {
    return false;
  }

  const normalizedPhrase = phrase.toLowerCase().trim();
  return MULTISPORT_PHRASES.includes(normalizedPhrase);
};

export default isMultisportPhrase;
